import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

const useBadges = () => {
  const [badges, setBadges] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const badges = await dataProvider.getList("member-badges", {});
        setBadges(badges.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { badges, loading, error };
};

export default useBadges;
